import { ModalProps } from '@/types/shared'
import { Button, Dialog } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { InvoiceUpdate } from '@/modules/Invoice/types'
import { FormItem } from 'vnetwork-ui'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { createInvoiceUpdate } from '@/modules/Invoice/services'
import useDataGridRefetch from '@/hooks/useDataGridRefetch'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

export interface AddInvoiceUpdateProps extends ModalProps {
    invoice_id: number
}
const AddInvoiceUpdate: React.FC<AddInvoiceUpdateProps> = ({
    open,
    onClose,
    invoice_id,
}) => {
    const { t } = useTranslation()
    const { control, handleSubmit } = useForm<Partial<InvoiceUpdate>>({
        defaultValues: {
            invoice_update_description: '',
        },
    })

    const { refetchCurrent } = useDataGridRefetch({
        reactQueryKey: `invoice-${invoice_id}-logs`,
    })

    const {
        mutateAsync: createInvoiceUpdateMutation,
        isPending: isCreateUpdatePending,
    } = useMutationWithHandler(
        {
            mutationFn: createInvoiceUpdate,
        },
        {
            reactQueryKeys: QUERY_KEYS.INVOICES,
            successMessage: t('create-success'),
            onSuccess: () => {
                refetchCurrent()
                onClose()
            },
        }
    )

    const onSubmitHandler = async (data: Partial<InvoiceUpdate>) => {
        if (!data?.invoice_update_description?.trim()) return

        createInvoiceUpdateMutation({
            invoice_id,
            data,
        })
    }

    return (
        <Dialog open={open} onClose={onClose} title={t('add-invoice-update')}>
            <form
                onSubmit={handleSubmit(onSubmitHandler)}
                className="space-y-4"
            >
                <FormItem
                    control={control}
                    name="invoice_update_description"
                    type="textarea"
                    label={t('content')}
                    placeholder={t('enter-content')}
                />

                <div className="flex items-center justify-end gap-2">
                    <Button variant="outlined" onClick={onClose} type="button">
                        {t('cancel')}
                    </Button>
                    <Button
                        loading={isCreateUpdatePending}
                        disabled={isCreateUpdatePending}
                        type="submit"
                    >
                        {t('save')}
                    </Button>
                </div>
            </form>
        </Dialog>
    )
}

export default AddInvoiceUpdate
